export interface BasicDetails {
  analysisId?: number;
  stateId: number;
  districtId: number;
  ulbId: number;
  stateName: string;
  districtName: string;
  ulbName: string;
  sector: number;
  sectorAbbr: string;
  sectorName: string;
  proposalCost: string;
  analysisJSON: GapAnalysis;
}

export interface GapAnalysis {
  metaInfo: BasicInfo;
  basicInfo?: BasicInfo;
  sections: Section[];
  rules: Rules;
  data?: any; // for client driven form values
  ulbInfos?: any;
}
interface Rules {
  center_fund_Bifurcation: number | string;
  state_fund_Bifurcation: number | string;
  Has_ulb_notified_charges_for_MSW?: string;
  total_waste_generation_in_tpd?: number;
  no_of_vehicles?: number;
  atleast_one_required?: string[];
  cbDetails?: CB_Rules;
  [param: string]: any;
}

export interface CB_Rules {
  permanent: number;
  contractual: number;
  outsourced: number;
}

interface BasicInfo {
  title?: string;
  items: BasicInfoItem[];
}

interface BasicInfoItem {
  label: string;
  value: number | string;
}

interface Section {
  title?: string;
  items: Array<Cell[]>;
}

export interface Cell {
  key?: string;
  isEditable?: boolean;
  isAmount?: boolean;
  downloadLink?: boolean;
  validations?: Validation;
  value?: number | string;
  header?: boolean;
  colspan?: number;
  rowspan?: number;
  color?: string;
  section?: boolean;
  dependsOn?: string;
  difference?: boolean;
  hint?: string;
  link?: Array<string | number> | string;
  calculateDifference?: boolean;
  differenceKeys?: string[];
  mediaUrl?: string;
  [param: string]: any;
}
interface Validation {
  maxValue?: number;
  minValue?: number;
  restrict?: string;
  required?: boolean;
  decimalPlaces?: number;
}

export enum ProposalStatus {
  DRAFTED = 'DRAFTED',
  SUBMITTED_TO_STATE = 'SUBMITTED_TO_STATE',

  APPROVED_BY_STATE = 'APPROVED_BY_STATE',
  REJECTED_BY_STATE = 'REJECTED_BY_STATE',

  SUBMITTED_TO_SLTC = 'SUBMITTED_TO_SLTC',
  APPROVED_BY_SLTC = 'APPROVED_BY_SLTC',
  REJECTED_BY_SLTC = 'REJECTED_BY_SLTC',

  SUBMITTED_TO_CENTER = 'SUBMITTED_TO_CENTER',
  APPROVED_BY_CENTER = 'APPROVED_BY_CENTER',
  REJECTED_BY_CENTER = 'REJECTED_BY_CENTER',

  FOR_MOM_GENERATION = 'FOR_MOM_GENERATION',
  MOM_GENERATED = 'MOM_GENERATED',
}
export enum NatioanlProposalStatus {
  DRAFTED = 'DRAFTED',
  SUBMITTED_TO_STATE = 'SUBMITTED_TO_STATE',
  SUBMITTED_TO_CENTER='SUBMITTED_TO_CENTER',
  APPROVED_BY_CENTER= 'APPROVED_BY_CENTER',
  REJECTED_BY_CENTER= 'REJECTED_BY_CENTER',
  APPROVED_BY_SECTION='APPROVED_BY_SECTION',
  APPROVED_BY_TA='APPROVED_BY_TA',
  SUBMITTED_TO_TA='SUBMITTED_TO_TA',
  REJECTED_BY_SECTION='REJECTED_BY_SECTION',
  REJECTED_BY_TA='REJECTED_BY_TA'
}
